import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { CREATE_LOCATION_ENVIRONMENT_MUTATION, GET_LOCATION_ENVIRONMENT_QUERY, SEARCH_LOCATION_ENVIRONMENTS_QUERY, UPDATE_LOCATION_ENVIRONMENT_MUTATION } from './location-environment.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var LocationEnvironmentApi = /** @class */ (function () {
    function LocationEnvironmentApi(apollo) {
        this.apollo = apollo;
    }
    LocationEnvironmentApi.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: GET_LOCATION_ENVIRONMENT_QUERY,
                        variables: { id: id },
                    }).toPromise()
                        .then(function (response) { return response.data && response.data.locationEnvironment; })];
            });
        });
    };
    LocationEnvironmentApi.prototype.search = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.query({
                        query: SEARCH_LOCATION_ENVIRONMENTS_QUERY,
                        variables: params,
                    }).toPromise()
                        .then(function (response) { return response.data && response.data.locationEnvironments; })];
            });
        });
    };
    LocationEnvironmentApi.prototype.create = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: CREATE_LOCATION_ENVIRONMENT_MUTATION,
                        variables: { input: params },
                    }).toPromise()
                        .then(function (response) { return response.data && response.data.createLocationEnvironment; })];
            });
        });
    };
    LocationEnvironmentApi.prototype.update = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: UPDATE_LOCATION_ENVIRONMENT_MUTATION,
                        variables: { input: params },
                    }).toPromise()
                        .then(function (response) { return response.data && response.data.updateLocationEnvironment; })];
            });
        });
    };
    LocationEnvironmentApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationEnvironmentApi_Factory() { return new LocationEnvironmentApi(i0.ɵɵinject(i1.Apollo)); }, token: LocationEnvironmentApi, providedIn: "root" });
    return LocationEnvironmentApi;
}());
export { LocationEnvironmentApi };
